import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/NoClaimsIllustration.tsx
const NoClaimsIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "no-claims.svg",
		alt: t("illustration.imageAlt.noClaims")
	});
};

//#endregion
export { NoClaimsIllustration };